declare namespace $ {

	export class $mol_icon_autorenew extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=autorenew.view.tree.d.ts.map